import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import { sectorCommunicator } from '../../../communicators/sectorCommunicator'

import { PageInfo } from '../../components/PageInfo/PageInfo'
import { ArrowLinkListSection } from '../../components/ArrowLinkListSection/ArrowLinkListSection'
import SectorNewsSection from './SectorNewsSection'
import { ContactSection } from '../../components/ContactSection/ContactSection'
import { Page } from '../../components/Page/Page'

import './Sector.css'
import { SECTORS } from '../../../config/pks-constants'

class Sector extends Component {
    constructor(props) {
        super(props)

        this.state = {
            sector: null,
            sectorImage: '',
            isLoading: true
        }
        this.sectorSlug = this.props.match.params.slug
        this.sectorId = SECTORS[this.sectorSlug]
    }

    componentDidMount() {
        this.loadSectorInfo()
    }

    async loadSectorInfo() {
        const sectorImages = [
            {
                id: 5,
                image: '/images/industry-page-info.png'
            },
            {
                id: 6,
                image: '/images/services-page-info.png'
            },
            {
                id: 8,
                image: '/images/agro-page-info.png'
            }
        ]

        try {
            const sector = await sectorCommunicator.fetch(this.sectorId)
            const { image } = sectorImages.find(item => item.id === this.sectorId)

            this.setState({
                sector,
                sectorImage: image,
                isLoading: false
            })
        } catch (error) {
            console.error(error)
            this.setState({ isLoading: false })
        }
    }

    onAssociationClick = e => {
        this.props.history.push(`/udruzenje/${e.currentTarget.id}`)
    }

    render() {
        const { t } = this.props
        const { sector, sectorImage, isLoading } = this.state

        const sectorInfo = t('sectorsInfo')[this.sectorSlug]

        const metaTitle = sectorInfo && sectorInfo.title
        const metaDescription = sectorInfo && sectorInfo.description

        return (
            <Page isLoading={isLoading} title={metaTitle} description={metaDescription}>
                {sector && (
                    <>
                        <PageInfo
                            breadcrumbs={t('sector.breadcrumbs')}
                            title={sector.name}
                            icon={sectorImage}
                        />
                        <ArrowLinkListSection
                            title={t('sector.associationsSection.title')}
                            list={sector.associations}
                            onClick={this.onAssociationClick}
                            moreTitle={t('sector.associationsSection.showMore')}
                            lessTitle={t('sector.associationsSection.showLess')}
                            hasSlug
                        />
                        <SectorNewsSection sectorId={this.sectorId} sectorSlug={this.sectorSlug} />
                        <ContactSection
                            contacts={sector.contacts}
                            title={t('sector.contactSection.title')}
                        />
                    </>
                )}
            </Page>
        )
    }
}

Sector.propTypes = {
    t: PropTypes.func
}

export default withTranslation()(Sector)
